import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.css";
import ElderLogin from "./components/elderLogin";
import ElderRegister from "./components/elderRegister";
import ElderProfileSetup from "./components/elderProfileSetup";
import ElderIntroPage from "./components/elderIntroPage";
import ElderMap from "./components/eldermap";
import ElderHome from "./components/elderHome";
import Logout from "./components/logout";
import LanguageSwitcher from "./components/LanguageSwitcher";
import ElderMarketingPage from "./components/ElderMarketingPage";
import logo from "./images/cape.png";

const AppContent = () => {
  const { t } = useTranslation("common");
  const location = useLocation();
  const isMarketingPage = location.pathname === "/elder-marketing";

  return (
    <div className="app-shell">
      {isMarketingPage ? (
        <header className="topbar topbar-minimal">
          <Link to="/" className="topbar-brand topbar-brand-minimal" aria-label="Go to home page">
            <img src={logo} alt="UberCARE for Elders logo" className="topbar-logo" />
            <span className="topbar-brand-copy">
              <span className="topbar-kicker">Care that feels easier to reach</span>
              <span className="topbar-title">{t("nav.brand")}</span>
            </span>
          </Link>
        </header>
      ) : (
        <header className="topbar">
          <Link to="/" className="topbar-brand">
            <img src={logo} alt="UberCARE for Elders logo" className="topbar-logo" />
            <span className="topbar-brand-copy">
              <span className="topbar-kicker">Care that feels easier to reach</span>
              <span className="topbar-title">{t("nav.brand")}</span>
            </span>
          </Link>

          <nav className="topbar-links" aria-label="Primary navigation">
            <Link className="nav-link" to="/">
              {t("nav.home")}
            </Link>
            <Link className="nav-link" to="/elder-login">
              {t("nav.elderLogin")}
            </Link>
            <Link className="nav-link" to="/elder-register">
              {t("nav.elderRegister")}
            </Link>
            <Logout />
            <LanguageSwitcher />
          </nav>
        </header>
      )}

      <main className="page-offset">
        <Routes>
          <Route path="/" element={<ElderHome />} />
          <Route path="/elder-home" element={<Navigate to="/" replace />} />
          <Route path="/elder-login" element={<ElderLogin />} />
          <Route path="/elder-register" element={<ElderRegister />} />
          <Route path="/elder-profile-setup" element={<ElderProfileSetup />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/elder-map" element={<ElderMap />} />
          <Route path="/elder-intro" element={<ElderIntroPage />} />
          <Route path="/elder-marketing" element={<ElderMarketingPage />} />
        </Routes>
      </main>
    </div>
  );
};

const App = () => {
  return (
    <Router basename="/elder">
      <AppContent />
    </Router>
  );
};

export default App;
